import React from "react";

export default function Cart() {
  return (
    <div>
      <h1>Cart Page</h1>
      {/* Add cart details here */}
    </div>
  );
}
